import { render, staticRenderFns } from "./RegistrationFieldsDropdown.vue?vue&type=template&id=e59a805e&scoped=true&"
import script from "./RegistrationFieldsDropdown.vue?vue&type=script&lang=js&"
export * from "./RegistrationFieldsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./RegistrationFieldsDropdown.vue?vue&type=style&index=0&id=e59a805e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e59a805e",
  null
  
)

export default component.exports